export default __webpack_public_path__ + "static/media/double-left.ef090274.svg";